var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-broadcast-list" },
    [
      _c("div", { staticClass: "header-container" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("message.emailBroadcasts")))]),
        _vm._v(" "),
        _c("div", { staticClass: "broadcast-limit" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.monthlyDetail
                  ? _vm.$t("message.monthlyLimit") +
                      ": " +
                      (_vm.site.monthlyMailSendLimit || 5000) +
                      " / " +
                      _vm.monthlyDetail.count +
                      " " +
                      _vm.$t("mail.sent")
                  : ""
              ) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.isCreatingBroadcast
        ? _c(
            "div",
            [
              _c("div", { staticClass: "toolbar-container" }, [
                _c("div", { staticClass: "left-section" }, [
                  _c("div", { staticClass: "view-switcher" }, [
                    _c(
                      "div",
                      { staticClass: "supsis-button-group" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: {
                              primary: _vm.mode === "active",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setMode("active")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.active")) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            attrs: {
                              primary: _vm.mode === "archived",
                              small: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setMode("archived")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.archived")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right-section" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.toggleCreateBroadcast },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.createBroadcast")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("supsis-table", {
                attrs: {
                  columns: _vm.columns,
                  rows: _vm.emailBroadcasts,
                  "pagination-cursor": _vm.paginationCursor,
                  "top-pagination": true,
                  "bottom-pagination": true,
                },
                on: { "cursor-changed": _vm.paginationChanged },
              }),
            ],
            1
          )
        : _c("EmailBroadcast", {
            on: { "broadcast-created": _vm.onBroadcastCreated },
          }),
      _vm._v(" "),
      _vm.broadcastDetail
        ? _c(
            "a-modal",
            {
              attrs: {
                visible: !!_vm.broadcastDetail,
                title: _vm.$t("message.broadcastDetails"),
                width: "80%",
              },
              on: { cancel: _vm.closeBroadcastDetail },
            },
            [
              !_vm.detailedBroadcastReport
                ? _c("a-alert", {
                    attrs: {
                      message: _vm.$t("message.youCanCheckYourEmailStatus"),
                      type: "warning",
                      "show-icon": "",
                      banner: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-detail" }, [
                _c(
                  "div",
                  {
                    staticClass: "broadcast-detail-item",
                    attrs: { status: _vm.showingBroadcast.status },
                  },
                  [
                    _c("div", { staticClass: "broadcast-detail-item-title" }, [
                      _vm._v(_vm._s(_vm.$t("message.status"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "broadcast-detail-item-value" }, [
                      _vm._v(
                        _vm._s(_vm.getStatus(_vm.showingBroadcast.status))
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "broadcast-detail-item",
                    attrs: {
                      completed: _vm.showingBroadcast.status === "completed",
                    },
                  },
                  [
                    _c("div", { staticClass: "broadcast-detail-item-title" }, [
                      _vm._v(_vm._s(_vm.$t("message.sentDetails"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "broadcast-detail-item-value" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.showingBroadcast.lastSentIndex) +
                          " / " +
                          _vm._s(_vm.showingBroadcast.total) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-detail-item success" }, [
                  _c("div", { staticClass: "broadcast-detail-item-title" }, [
                    _vm._v(_vm._s(_vm.$t("task.success"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-detail-item-value" }, [
                    _vm._v(_vm._s(_vm.showingBroadcast.successMessageCount)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-detail-item failed" }, [
                  _c("div", { staticClass: "broadcast-detail-item-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.failed"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-detail-item-value" }, [
                    _vm._v(_vm._s(_vm.showingBroadcast.failedMessageCount)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-status" }, [
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "total" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("email"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [_vm._v(_vm._s(_vm.$t("message.total")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.total))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalEmailsProcessed")))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "delivered" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("check"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.delivered")) +
                            " " +
                            _vm._s(
                              _vm.detailedBroadcastReport
                                ? this.$t("message.mockData")
                                : ""
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.delivery))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalEmailsDelivered")))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "bounced" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("error"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [_vm._v(_vm._s(_vm.$t("message.bounced")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.bounce))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalEmailsBounced")))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "bounced" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("error"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [
                        _vm._v(
                          "\n                         " +
                            _vm._s(_vm.$t("message.complaint")) +
                            " " +
                            _vm._s(
                              !_vm.detailedBroadcastReport
                                ? this.$t("message.mockData")
                                : ""
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.complains))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [_vm._v(_vm._s(_vm.$t("message.totalEmailsComplained")))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "open" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("visibility"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [
                        _vm._v(
                          "\n                       " +
                            _vm._s(_vm.$t("message.opens")) +
                            " " +
                            _vm._s(
                              !_vm.detailedBroadcastReport
                                ? this.$t("message.mockData")
                                : ""
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.open))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.untilNowTotalEmailOpens"))
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "click" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("link"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [
                        _vm._v(
                          "\n                       " +
                            _vm._s(_vm.$t("message.clicks")) +
                            " " +
                            _vm._s(
                              !_vm.detailedBroadcastReport
                                ? this.$t("message.mockData")
                                : ""
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.click))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.untilNowTotalEmailLinkClicks"))
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "broadcast-status-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "broadcast-status-item-icon",
                      attrs: { type: "unique-click" },
                    },
                    [
                      _c("div", { staticClass: "material-icons" }, [
                        _vm._v("link"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "broadcast-status-item-detail" }, [
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-title" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.uniqueClicks")) +
                            " " +
                            _vm._s(
                              !_vm.detailedBroadcastReport
                                ? this.$t("message.mockData")
                                : ""
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "broadcast-status-item-detail-value" },
                      [_vm._v(_vm._s(_vm.broadcastDetail.stats.uniqClick))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "broadcast-status-item-detail-description",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.untilNowTotalUniqueEmail")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-campaign-chart" }, [
                _c("div", { staticClass: "broadcast-campaign-chart-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.emailCampaignTimeline"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "broadcast-campaign-chart-body" },
                  [
                    _c("ECharts", {
                      staticClass: "echart-graph",
                      attrs: { option: _vm.getChartOption() },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "broadcast-campaign-chart" }, [
                _c("div", { staticClass: "broadcast-campaign-chart-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.receivedBroadcasts"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "broadcast-campaign-chart-body" },
                  [
                    _c("supsis-table", {
                      attrs: {
                        columns: _vm.getReceivedBroadcastColumns(),
                        rows: _vm.broadcastDetail.receives,
                        "pagination-cursor": _vm.receiverPaginationCursor,
                        "top-pagination": true,
                        "bottom-pagination": true,
                        paginationOptions: [5],
                      },
                      on: { "cursor-changed": _vm.receiverPaginationChanged },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }